import { render, staticRenderFns } from "./EditStockWarning.vue?vue&type=template&id=9aabac60&scoped=true&"
import script from "./EditStockWarning.vue?vue&type=script&lang=js&"
export * from "./EditStockWarning.vue?vue&type=script&lang=js&"
import style0 from "./EditStockWarning.vue?vue&type=style&index=0&id=9aabac60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aabac60",
  null
  
)

export default component.exports